import { getIdToken } from "../auth/cognitoAuth";
import { restBaseUrl, apiMode } from "./config";

const LOG = "[TEAM REST]";

async function authHeader() {
  try {
    const token = await getIdToken();
    if (!token) {
      console.error(`${LOG} no Cognito session — requests will 401`);
      return {};
    }
    return { Authorization: `Bearer ${token}` };
  } catch (err) {
    console.error(`${LOG} no Cognito session — requests will 401`, err);
    return {};
  }
}

export async function restFetch(path, { method = "GET", body } = {}) {
  if (!restBaseUrl) {
    const err = new Error("REACT_APP_TEAM_REST_URL is not set");
    console.error(`${LOG}`, err);
    throw err;
  }
  const url = `${restBaseUrl}${path}`;
  const headers = {
    "Content-Type": "application/json",
    ...(await authHeader()),
  };
  console.debug(`${LOG} → ${method} ${url}`, body !== undefined ? body : "");
  let res;
  try {
    res = await fetch(url, {
      method,
      headers,
      body: body === undefined ? undefined : JSON.stringify(body),
    });
  } catch (err) {
    console.error(`${LOG} network error ${method} ${path}`, err);
    throw err;
  }
  const text = await res.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = text;
  }
  if (!res.ok) {
    const msg = (data && data.message) || (data && data.error) || res.statusText;
    console.error(`${LOG} ← ${res.status} ${method} ${path}`, data || msg);
    throw new Error(`REST ${method} ${path} failed: ${res.status} ${msg}`);
  }
  console.debug(`${LOG} ← ${res.status} ${method} ${path}`, data);
  return data;
}

if (typeof console !== "undefined") {
  console.info(`${LOG} apiMode=${apiMode} baseUrl=${restBaseUrl || "(none)"}`);
}
